import moment from 'moment'

export const ticket = {
  id: '',
  department: '',
  name: '',
  employeeNumber: '',
  categoryObserve: '',
  date: moment().format('YYYY-MM-DD'),
  assignedTo: '',
  questionStatus: '',
  remark: '',
  qboAdminRemark: '',
  categoryLevel: ''
}

export const ticketDetail = {
  id: '',
  cparNo: '',
  department: '',
  employeeId: '',
  employeeName: '',
  otherEmployeeName: '',
  otherEmployeeNumber: '',
  date: moment().format('YYYY-MM-DD'),
  areaObserve: '',
  areaOwnerId: '',
  areaOwnerName: '',
  PIC: '',
  DIC: '',
  categoryObserve: '',
  problemDetail: '',
  assignedTo: '',
  assignedtoName: '',
  assignedToDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
  evidence: '',
  remark: '',
  ownerAreaRemark: '',
  remarkMachineRootCause: '',
  remarkManRootCause: '',
  remarkMaterialRootCause: '',
  remarkMethodRootCause: '',
  remarkEnvironmentRootCause: ''
}

export const correctiveCorrectionAction = {
  id: '',
  questionListId: '',
  actionNo: '',
  rootCauseType: '',
  rootCauseRemark: '',
  actionType: '',
  actionRemark: '',
  workDescription: '',
  evidence: '',
  picId: '',
  targetDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  createdBy: '',
  createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
  updatedBy: '',
  updatedAt: moment().format('YYYY-MM-DD HH:mm:ss')
}